exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiplePhotos__uploader___37pyO {\n  width: 100%;\n  max-width: 150px;\n  height: 150px;\n  display: block; }\n  .multiplePhotos__uploader___37pyO > div {\n    width: 100% !important;\n    height: 100% !important;\n    border-radius: 5px !important; }\n  .multiplePhotos__uploader___37pyO .multiplePhotos__addPhoto___W1Q6b {\n    font-size: 40px; }\n", ""]);

// exports
exports.locals = {
	"uploader": "multiplePhotos__uploader___37pyO",
	"addPhoto": "multiplePhotos__addPhoto___W1Q6b"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/PhotoUploader/MultiplePhotos/multiplePhotos.scss
// module id = 2256
// module chunks = 6